export const controlKey = '^';
export const optionKey = '⌥';
export const commandKey = '⌘';
export const shiftKey = '⇧';
export const backspaceKey = '⌫';

export function isOSMac(): boolean {
    return navigator.platform.includes('Mac');
}

export const metaKey = isOSMac() ? '⌘' : 'Ctrl + ';
